import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const read = () => localStorage.getItem('overviewGlobal') === 'true';

// True when the Global view toggle is on and the user is on the Overview (/home).
export function useOverviewGlobal() {
  const { pathname } = useLocation();
  const [on, setOn] = useState(read);
  useEffect(() => {
    const sync = () => setOn(read());
    window.addEventListener('overview:global', sync);
    return () => window.removeEventListener('overview:global', sync);
  }, []);
  return on && pathname === '/home';
}
